import type React from "react";
import { AiMessage } from "./AiMessage";
import type { ChatMessageProps } from "./types";
import { UserMessage } from "./UserMessage";

export const ChatMessage: React.FC<ChatMessageProps> = (props) => {
  const MessageComponent = props.message.role === "user" ? UserMessage : AiMessage;
  return <MessageComponent {...props} />;
};
